
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.359 25h19.884a2.36 2.36 0 002.36-2.36V10.011a.668.668 0 00-.24-.51l-3.29-2.782V1.872A1.872 1.872 0 0019.2 0H5.533a1.871 1.871 0 00-1.872 1.872v4.746L.238 9.501a.668.668 0 00-.238.511V22.64A2.36 2.36 0 002.359 25zm19.883-1.337H2.359a1.024 1.024 0 01-1.022-1.024V11.288l7.622 5.39-5.41 4.14a.668.668 0 10.802 1.07l5.753-4.402 1.871 1.337c.231.164.542.164.773 0l1.872-1.337 5.755 4.394a.668.668 0 10.802-1.07l-5.399-4.131 7.488-5.295v11.258a1.023 1.023 0 01-1.022 1.021h-.002zm.65-13.654l-1.82 1.286V8.469l1.82 1.54zM5.532 1.34h13.67a.535.535 0 01.535.535v10.359l-7.37 5.218-7.367-5.218V1.872a.535.535 0 01.532-.532zm3.494 4.516a1.926 1.926 0 012.83 0l.643.678.639-.674a1.926 1.926 0 012.83 0 2.183 2.183 0 010 2.981L12.496 12.5l-3.47-3.663a2.184 2.184 0 010-2.98zM3.662 8.354v2.942L1.769 9.959l1.893-1.605z"}})])
          )
        }
      }
    